import { SelectLocationControllerCmpDesktop } from '@porterin/component-library/src/location-accuracy/components/SelectLocationControllerCmpDesktop';
import React from 'react';

export interface LocationAccuracyProps {
  close_modal: () => void;
}

export const LocationAccuracyCmpDesktop: React.FC<LocationAccuracyProps> = ({
  close_modal,
}) => {
  return (
    <div
      data-testid="select-location-wrapper h-full"
      className="w-full h-full overflow-y-auto box-border bg-white relative"
    >
      <SelectLocationControllerCmpDesktop close_modal={close_modal} />
    </div>
  );
};
